import GetWidgetEventsRequestModelBase from '../_generated/modelBases/get-widget-events-request-model-base';

export default class GetWidgetEventsRequestModel extends GetWidgetEventsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
